module.exports = __webpack_public_path__ + "static/media/intro__mixer.167d180b.png";